module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "titlePage",
    attrs: {
      "id": "titlepage"
    }
  }, [_c('a', {
    attrs: {
      "id": "page03"
    }
  }, [_c('h2', {
    staticClass: "titlePageTitle",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_vm._v("Psychic")]), _vm._v(" "), _c('p', {
    staticClass: "titlePageSubtitle",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_vm._v("My Life in Two Worlds")]), _vm._v(" "), _c('h2', {
    staticClass: "titlePageAuthor",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_vm._v("Sylvia Browne")]), _vm._v(" "), _c('h2', {
    staticClass: "titlePageAuthor1",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_vm._v("With Lindsay Harrison")]), _vm._v(" "), _c('p', {
    staticClass: "colophon"
  }, [_c('img', {
    staticClass: "epubimage",
    attrs: {
      "alt": "image",
      "src": "Images/logo.jpg"
    }
  })])])]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "page03"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-372a57fb","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/002titlepage.vue
// module id = 60
// module chunks = 0